module.exports = __webpack_public_path__ + "static/media/BOO.d95741d5.png";